/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V3DealList } from '../models/V3DealList';
import { HttpFile } from '../http/http';

export class V3ListXandrDealListsResponse {
    'dealLists'?: Array<V3DealList>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "dealLists",
            "baseName": "deal_lists",
            "type": "Array<V3DealList>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V3ListXandrDealListsResponse.attributeTypeMap;
    }

    public constructor() {
    }
}

